import Vue from "vue";
import methods from "./modules/methods";
import './modules/String.js'
import './modules/Date.js'
Object.assign(Vue.prototype, methods);